import React, { useContext } from "react";
import { Layout, Menu, Dropdown } from "antd";
import { LogoutOutlined } from "@ant-design/icons";
import { Store } from "../store";

const Header = () => {
  const { state, dispatch } = useContext(Store);
  const onClickLogout = () => {
    localStorage.setItem("monitoring_system", "");
    dispatch({
      type: "LOGOUT",
    });
  };

  const menu = (
    <Menu className="user-menu">
      <Menu.Item onClick={onClickLogout} icon={<LogoutOutlined />}>
        ログアウト
      </Menu.Item>
    </Menu>
  );
  return (
    <Layout.Header className="header-home">
      <Dropdown overlay={menu}>
        <div className="user-name">{`こんにちは${state.session.name}さん`}</div>
      </Dropdown>
    </Layout.Header>
  );
};

export default Header;
